import { inject, Injectable, NgZone } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface LmsMessage {
	type: LmsParentMessage;
	payload?: any;
}

export type AllowedLmsParentApp = 'lms_scorm';
export type LmsParentMessage = 'scormReady' | 'scormInitializationFailed';

@Injectable({ providedIn: 'root' })
export class LmsMessageBus {

	private readonly parentMessage$ = new BehaviorSubject<LmsMessage | null>(null);
	private readonly zone: NgZone = inject(NgZone);

	private readonly allowedParentApps: AllowedLmsParentApp[] = ['lms_scorm'];
	public readonly allowedMessageTypes: LmsParentMessage[] = [
		'scormReady',
		'scormInitializationFailed'
	];

	constructor() {
		window.addEventListener('message', this.lmsListener);
	}

	private readonly lmsListener = (event: MessageEvent) => {

		if (!event.data) {return;}

		if (!this.allowedParentApps.includes(event.data.app)) {
			return;
		}

		if (!this.allowedMessageTypes.includes(event.data.type)) {
			return;
		}

		const { type, payload } = event.data;

		this.zone.run(() => {
			const current = this.parentMessage$.value;

			if (current?.type === type) {
				console.log(`Received duplicate message of type ${type} from LMS parent, ignoring.`);
				return;
			}
			console.log(`Received message of type ${type} from LMS parent with payload:`, payload);
			this.parentMessage$.next({ type, payload });
		});
	};

	public subscribeLmsParent(): Observable<LmsMessage | null> {
		return this.parentMessage$.asObservable();
	}
}
